<!-- <template>

<div class="grid-content bg-purple">
<h2 style="float: left;">平台评分列表</h2>
<el-tag
  v-for="item in items"
  :key="item.id"
  :type="item.type"
  @click="selecTopera(item.id)"
  :class="{active : item.id===curId}"
  effect="light">
{{ item.label }}
</el-tag>
<div class="table-box">


<el-table
  :data="operator"
  height="550"
  border
  style="width: 100%;">
  <el-table-column
    label="季度"
    width="180">
    <template slot-scope="scope">
      {{scope.row.year}}年第({{scope.row.quarter}})季
    </template>
  </el-table-column>
  <el-table-column
    prop="operatorName"
    label="运营企业"
    width="180">
  </el-table-column>
  <el-table-column
    prop="totalPoints"
    label="季度评分">
  </el-table-column>
  <el-table-column
    prop="grade"
    label="季度评分排名">
  </el-table-column>

  <el-table-column

    label="操作">
    <template slot-scope="scope">
      <el-button
        size="mini"
        type="success"
        @click="openEdit(scope.row.gradeId,2)"
      >查看详情</el-button>
    </template>
  </el-table-column>
</el-table>
<el-pagination
  background
  layout="prev, pager, next"
  :page-size="operatorpageSize"
  @current-change="setselecTopera"
  :total="operatortotal">

</el-pagination>
</div>
  </div>
</template>
<script>
export default {
  name: "Auditlaw",
  data(){
    return {
      items: [
        {   id:1,
          type: 'success',
          code:'MT'
        },
        {   id:2,
          type: 'info',
          code:'HB'
        },
        {
          id:3,
          type: 'danger',
          code:'DD'
        },
      ],
      operatorpage:1,
      operatortotal:0,
      operatorpageSize:10,
      operator:[],
      curId:1,
    }
  },
  beforeRouteEnter(to,from,next){

    next((vm)=>{

    });
  },
  created(){

  },
  mounted () {
    this.selecTopera(1)
  },
  methods: {
    // 获取评分列表
    selecTopera(index){
      let that = this;
      this.curId = index;
      let operators ={
        page:this.operatorpage,
        pageSize:this.operatorpageSize,
        operatorNum:index ,
      }
      this.$axios.defaults.withCredentials=true;
      this.$axios
        .post('/api/grade/selectGradeList',operators)
        .then(function (res) {
          that.operatortotal = res.data.data.total;
          that.operator = res.data.data.list;
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },
    setselecTopera(operatorpage){
      this.operatorpage = operatorpage;
      this.selecTopera(this.curId);
    },
    openEdit(cid,typeid){
      this.$router.push({name:'Ashowscore' , params:{cid:cid ,curId:this.curId, typeid:typeid}})
    },
  },
  watch: {

  },
}
</script>
 -->

<template>
  <div class="media-uploader">
    <div v-for="(uploader, index) in uploaders" :key="index" class="upload-item">
      <div class="upload-header">
        <h3>上传项 {{ index + 1 }}</h3>
        <button @click="removeUploader(index)" v-if="uploaders.length > 1" class="remove-btn">
          ×
        </button>
      </div>
      
      <div class="upload-area" @click="triggerFileInput(index)">
        <input 
          type="file" 
          :ref="'fileInput'+index"
          @change="handleFileChange($event, index)"
          accept="image/*,video/*"
          style="display: none"
		  name="files"
        >
        <div v-if="!uploader.file" class="upload-placeholder">
          <i class="fas fa-cloud-upload-alt"></i>
          <p>点击上传图片或视频</p>
        </div>
        <div v-else class="preview-container">
          <img v-if="isImage(uploader.file)" :src="uploader.preview" alt="上传的图片预览">
          <video v-else controls>
            <source :src="uploader.preview" :type="uploader.file.type">
          </video>
          <div class="file-info">
            <p>{{ uploader.file.name }}</p>
            <p>{{ formatFileSize(uploader.file.size) }}</p>
          </div>
        </div>
      </div>

      <div class="upload-status" v-if="uploader.status">
        {{ uploader.status }}
      </div>
    </div>

    <button @click="addUploader" class="add-btn">
      + 添加上传项
    </button>

    <button @click="submitAll" class="submit-btn" :disabled="!hasFiles">
      提交所有文件
    </button>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'MediaUploader',
  data() {
    return {
      uploaders: [
        { file: null, preview: null, status: null }
      ]
    }
  },
  computed: {
    hasFiles() {
      return this.uploaders.some(u => u.file);
    }
  },
  methods: {
    addUploader() {
      this.uploaders.push({ file: null, preview: null, status: null });
    },
    removeUploader(index) {
      this.uploaders.splice(index, 1);
    },
    triggerFileInput(index) {
      this.$refs[`fileInput${index}`][0].click();
    },
    handleFileChange(event, index) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        this.uploaders[index].file = file;
        this.uploaders[index].preview = e.target.result;
        this.uploaders[index].status = '待上传';
        this.$forceUpdate();
      };
      reader.readAsDataURL(file);
    },
    isImage(file) {
      return file.type.startsWith('image/');
    },
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    async submitAll() {
      const formData = new FormData();
      
      this.uploaders.forEach((uploader, index) => {
        if (uploader.file) {
          // formData.append(`file_${index}`, uploader.file);
          formData.append(`files`, uploader.file);
          this.uploaders[index].status = '上传中...';
        }
      });
      try {
        const response = await axios.post('/api/upload/imgs', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
       
        this.uploaders.forEach((uploader, index) => {
          if (uploader.file) {
            this.uploaders[index].status = '上传成功';
          }
        });
        
        console.log('上传成功:', response.data);
        alert('所有文件上传成功！');
      } catch (error) {
        console.error('上传失败:', error);
        
        this.uploaders.forEach((uploader, index) => {
          if (uploader.file) {
            this.uploaders[index].status = '上传失败';
          }
        });
        
        alert('上传失败，请重试');
      }
    }
  }
}
</script>

<style scoped>
.media-uploader {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.upload-item {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.upload-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.remove-btn {
  background: #ff6b6b;
  color: white;
  border: none;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-area {
  border: 2px dashed #adb5bd;
  border-radius: 6px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  margin-bottom: 15px;
}

.upload-area:hover {
  border-color: #4dabf7;
  background-color: rgba(77, 171, 247, 0.05);
}

.upload-placeholder {
  color: #868e96;
}

.upload-placeholder i {
  font-size: 48px;
  margin-bottom: 10px;
  color: #adb5bd;
}

.preview-container {
  position: relative;
}

.preview-container img, 
.preview-container video {
  max-width: 100%;
  max-height: 300px;
  display: block;
  margin: 0 auto;
}

.file-info {
  margin-top: 10px;
  color: #495057;
  font-size: 14px;
}

.upload-status {
  margin-top: 10px;
  font-size: 14px;
  color: #495057;
  text-align: center;
}

.add-btn, .submit-btn {
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.2s;
  margin-top: 10px;
}

.add-btn {
  background: #4dabf7;
  color: white;
}

.add-btn:hover {
  background: #339af0;
}

.submit-btn {
  background: #40c057;
  color: white;
}

.submit-btn:hover:not(:disabled) {
  background: #2f9e44;
}

.submit-btn:disabled {
  background: #adb5bd;
  cursor: not-allowed;
}
</style>




// WEBPACK FOOTER //
// src/view/admin/Auditlaw.vue